// eslint-disable-next-line import/prefer-default-export
export const columns = [
    {
        id: 'source',
        sortable: true
    },
    {
        id: 'category',
        sortable: true
    },
    {
        id: 'businessDate',
        sortable: true
    },
    {
        id: 'timestamp',
        sortable: true
    },
    {
        id: 'destination',
        sortable: true
    },
    {
        id: 'errorMessage',
        sortable: true
    },
    {
        id: 'status',
        sortable: true
    }
];
